export default "__VITE_PUBLIC_ASSET__7f123aa6__"